//TODO: Make this more generic, a hero organism, if used in other places

import Swiper, { Autoplay, EffectFade, A11y } from 'swiper';
Swiper.use([Autoplay, EffectFade, A11y]);

const swiper = new Swiper('.swiper-hero-container', {
  // Optional parameters
  slidesPerView: 1,
  allowTouchMove: false,
  speed: 400,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 5000,
  },
});